export const cryptoCompareAPI = '6f7691cf5bfb69fc2bd50560496837aaea4cf08465e696feb051ef5f32821573';